import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationExtras } from "@angular/router";
import { NbToastrService } from "@nebular/theme";
import { Globals } from "../globals";
import { SetupService } from "../services/setup.service";
import * as _ from "underscore";
import * as __ from "lodash";
import { firstValueFrom } from 'rxjs'
import { filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: "root",
})
export class AdminRoutingGuard implements CanActivate {
  constructor(
    public globals: Globals,
    private setupService: SetupService,
    private toastrService: NbToastrService
  ) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    //v2-let access = this.globals.access;
    console.log("canActivate")

    // Wait until userReady$ is true
    await firstValueFrom(
      this.setupService.userReady$.pipe(
        filter(ready => ready)
      )
    );

    // Now safe to use global data
    console.log("switchEvaluation")
    return this.switchEvaluation(state);
  }

  async delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  
  switchEvaluation(state: RouterStateSnapshot): boolean {
    let access = this.globals.isAdmin;
    switch (state.url) {
      case "/admin/users":
        //v2-if (!access.registrations) {
        if (!access) {
          this.showNotification("Tu n'as pas accès à cette page, contacte le pilotage du WESKI", "danger");
          return false;
        } else {
          return true;
        }
        break;
      case "/admin/transportation":
        //v2-if (!access.transportations) {
        if (!access) {
          this.showNotification("Tu n'as pas accès à cette page, contacte le pilotage du WESKI", "danger");
          return false;
        } else {
          return true;
        }
        break;
      case "/admin/activities":
        //v2-if (!access.activities) {
        if (!access) {
          this.showNotification("Tu n'as pas accès à cette page, contacte le pilotage du WESKI", "danger");
          return false;
        } else {
          return true;
        }
        break;
      case "/admin/equipment":
        //v2-if (!access.equipment) {
        if (!access) {
          this.showNotification("Tu n'as pas accès à cette page, contacte le pilotage du WESKI", "danger");
          return false;
        } else {
          return true;
        }
        break;
      case "/admin/setup":
        //v2-if (!access.setup) {
        if (!access) {
          this.showNotification("Tu n'as pas accès à cette page, contacte le pilotage du WESKI", "danger");
          return false;
        } else {
          return true;
        }
        break;
      case "/admin/bedrooms":
        //v2-if (!access.bedrooms) {
        if (!access) {
          this.showNotification("Tu n'as pas accès à cette page, contacte le pilotage du WESKI", "danger");
          return false;
        } else {
          return true;
        }
        break;
      case "/admin/terms":
        //v2-if (!access.terms) {
        if (!access) {
          this.showNotification("Tu n'as pas accès à cette page, contacte le pilotage du WESKI", "danger");
          return false;
        } else {
          return true;
        }
        break;
      case "/admin/frontend":
        //v2-if (!access.frontend) {
        if (!access) {
          this.showNotification("Tu n'as pas accès à cette page, contacte le pilotage du WESKI", "danger");
          return false;
        } else {
          return true;
        }
        break;
      case "/admin/export":
        //v2-if (!access.frontend) {
        if (!access) {
          this.showNotification("Tu n'as pas accès à cette page, contacte le pilotage du WESKI", "danger");
          return false;
        } else {
          return true;
        }
        break;
      case "/admin/logs":
        //v2-if (!access.frontend) {
        if (!access) {
          this.showNotification("Tu n'as pas accès à cette page, contacte le pilotage du WESKI", "danger");
          return false;
        } else {
          return true;
        }
        break;
      case "/admin/stalker":
        //v2-if (!access.frontend) {
        if (!access) {
          this.showNotification("Tu n'as pas accès à cette page, contacte le pilotage du WESKI", "danger");
          return false;
        } else {
          return true;
        }
        break;
      default:
        return false;
    }
  }

  showNotification(message, status, position: any = "bottom-right") {
    this.toastrService.show("", message, { status: status, hasIcon: false, position: position });
  }
}
